module.exports = __webpack_public_path__ + "static/img/97-1.0ab4fcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/97-1.jpg
// module id = 9gvq
// module chunks = 0